import { router } from "../router/router.js";

/**
 * Deep link único "CONFIGURAR PLH DO CLIENTE": leva ao cadastro do Cliente do
 * documento (Administração → Clientes), já com o Cliente aberto e o campo PLH
 * RESPONSÁVEL destacado, e preserva a origem para o retorno ao documento.
 * Nunca leva a Gestão → Projetos: Projeto não tem PLH.
 */
export const CLIENT_PLH_SETUP_ROUTE = "/management/clients";

export function clientPlhSetupHref(clientId: string, returnTo?: string): string {
  const origin = returnTo ?? `${window.location.pathname}${window.location.search}`;
  return `${CLIENT_PLH_SETUP_ROUTE}?clientId=${encodeURIComponent(clientId)}&focus=plh&returnTo=${encodeURIComponent(origin)}`;
}

export function openClientPlhSetup(clientId: string, returnTo?: string): void {
  router.navigate(clientPlhSetupHref(clientId, returnTo));
}
